module.exports = __webpack_public_path__ + "img/logo.273961b1.png";